import { Injectable } from "@angular/core";

@Injectable({
    providedIn: "root",
})
export class SessionStorageService {
    getItem(key: string) {
        return sessionStorage.getItem(key);
    }

    getObjectItem(key: string) {
        return JSON.parse(this.getItem(key));
    }

    saveItem(key: string, data: any) {
        if (!!data && typeof data === "object") {
            sessionStorage.setItem(key, JSON.stringify(data));
            return;
        }

        sessionStorage.setItem(key, `${data}`);
    }

    clearAll(excludes: string[] = []) {
        let excludeData: {
            key: string;
            data: string;
        }[] = null;
        if (excludes?.length > 0) {
            excludeData = excludes.map(ex => ({
                key: ex,
                data: this.getItem(ex),
            }));
        }

        sessionStorage.clear();

        if (excludeData?.length > 0) {
            excludeData.forEach(item => {
                if (item.data) {
                    this.saveItem(item.key, item.data);
                }
            });
        }
    }
}
